import axios from "axios";
import { SERVER } from "./SERVER";

class WaveguideDataService {
    getAllWaveguideFrames(token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/waveguide/frames`);
    }
    getAllWaveguideHoneycombs(token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/waveguide/honeycombs`);
    }
    getAllWaveguides(token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/waveguides/`);
    }
    getAllArchive(year, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/waveguides/year/${year}`);
    }
    createWaveguide(data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.post(`${SERVER}/api/create/waveguide/`, data);
    }
    getWaveguide(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.get(`${SERVER}/api/waveguide/${id}/`);
    }
    updateWaveguide(id, data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.put(`${SERVER}/api/waveguide/${id}/`, data);
    }
    deleteWaveguide(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.delete(`${SERVER}/api/waveguide/${id}/`);
    }
    toggleChecked(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.patch(`${SERVER}/api/waveguide/checked/${id}/`);
    }
    toggleArchived(id, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.post(`${SERVER}/api/waveguide/archive/${id}/`);
    }
    updateDueDate(id, data, token) {
        axios.defaults.headers.common["Authorization"] = "Token " + token;
        return axios.patch(`${SERVER}/api/waveguide/due/${id}/`, data);
    }
}

export default new WaveguideDataService();
